import { Navigate, useLocation } from 'react-router-dom';

import StyledWrapper from './style';

import ProgramDetails from './subPages/ProgramDetails/ProgramDetails';
import Budget from './subPages/Budget/Budget';
import GoalsAndMetrics from './subPages/GoalsAndMetrics/GoalsAndMetrics';
import ProgramNotifications from './subPages/ProgramNotifications/ProgramNotifications';

import ItemPageTitle from '../../components/ItemPageTitle/ItemPageTitle';
import VerticalNavigation from '../../components/VerticalNavigation/VerticalNavigation';
import { getTestTabs } from './mockData';
import ApplicationProcess from './subPages/StagesAndForms/ApplicationProcess';
import usePermissions from '../../hooks/usePermissions';
import { AUDITOR_ACCOUNT_TYPE } from '../../constants/common';
import { PROGRAMS } from '../../constants/routes';

const ProgramSetup = () => {
	const location = useLocation();
	const pathArray = location?.pathname?.split('/');
	const subPage = pathArray[pathArray.length - 1];
	const { userAccountTypeID } = usePermissions();
	const tabs = getTestTabs(userAccountTypeID);

	const chosenView = () => {
		const formattedSubPage = subPage?.replaceAll('%20', ' ');

		switch (formattedSubPage) {
			case 'program details':
				return <ProgramDetails />;
			case 'application':
				return <ApplicationProcess />;
			case 'budget':
				return <Budget />;
			case 'goals & metrics':
				return <GoalsAndMetrics />;
			case 'notifications':
				if (userAccountTypeID === AUDITOR_ACCOUNT_TYPE) {
					return <Navigate to={PROGRAMS} replace />;
				}
				return <ProgramNotifications />;
			default:
				return <></>;
		}
	};

	return (
		<StyledWrapper.OutermostContainer>
			<ItemPageTitle />
			<StyledWrapper.InnerContainer>
				<VerticalNavigation customInnerWidth={'180px'} data={tabs} />
				<StyledWrapper.MainContent>{chosenView()}</StyledWrapper.MainContent>
			</StyledWrapper.InnerContainer>
		</StyledWrapper.OutermostContainer>
	);
};

export default ProgramSetup;
